export const AlertBox=()=>{
    return(
        <div id="alert-container" className='fixed top-1 right-1 z-50 flex flex-col rounded-lg'></div>
    )
}